import { z } from 'zod';

export const credentialRepResDto = z.object({
  type: z.string(),
  // we only parse the required fields
});
